import React from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'

function ApprovalLoader({ message }: { message?: string }): React.JSX.Element {
	return (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'center',
				height: '100%',
				paddingBlock: '20%',
			}}
		>
			<Box sx={{ display: 'flex', flexDirection: 'column' }}>
				<Typography
					variant='body2'
					sx={{ color: 'white', fontFamily: 'var(--font-family)' }}
				>
					{message ?? 'A carregar dados, aguarde por favor'}
				</Typography>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'center',
						marginBlockStart: '1rem',
					}}
				>
					<CircularProgress sx={{ color: 'white' }} />
				</Box>
			</Box>
		</Box>
	)
}

export default ApprovalLoader
